import Vue from "vue";
import "vuetify/dist/vuetify.min.css";
import "@/scss/vuetify/overrides.scss";

const locales = {
  en: require('vuetify/es5/locale/en'),
  ja: require('vuetify/es5/locale/ja'),
  th: require('vuetify/es5/locale/th')
}

const current = navigator.language.split('-')[0]
import Vuetify, {
  VRow,
  VCol,
  VTextField,
  VTooltip,
  VCheckbox,
  VCombobox,
  VSelect,
  VTextarea,
  VCard,
  VSheet,

} from 'vuetify/lib';
import { Ripple, Intersect, Touch, Resize } from 'vuetify/lib/directives';
Vue.use(Vuetify, {
  components: { VSheet, VCard, VCombobox, VTextarea, VRow, VTooltip, VCol, VTextField, VCheckbox, VSelect },
  directives: { Ripple, Intersect, Touch, Resize },
});



const theme = {
  primary: "#1e88e5", // change header color from here || "#1e88e6", "#21c1d6", "#fc4b6c", "#563dea", "#9C27b0", "#ff9800"
  info: "#1e88e5",
  success: "#84C251",
  accent: "#fc4b6c",
  default: "#563dea",
};

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
    dark: false, // If you want to set dark theme then dark:true else set to false
  },
  rtl: false, // If you want to set rtl theme then rtl:true else set to false
  locales,
  current,
});
